class RecommendedReaCmaRequest extends MailtoFactory{

  constructor(options){
    super(options);
  }

  homeValue() {
    _.get(this.home, 'metadata.homeValue')
  }

  _to(){
    return '';
  }

  _subject(){
    return `Looking for a CMA for my client`;
  }

  _body(){

    return `Hello,

A client of mine, ${this.user.first_name} ${this.user.last_name}, has asked me (through Homebot) to provide them with a new estimated value of their home.  I have the option of picking someone to provide a CMA and I thought you might be interested.  It's a great opportunity to get to know a potential new client.  And, of course, I'll appreciate it.  If you are not interested, just let me know and I'll keep working my network for someone else who knows the area.

Homebot makes this super easy for us both.  Once you have a new value, give me a call or email with the new value (and range if possible) and then I'll update ${this.user.first_name}'s Homebot.

The details:

${this.$filter('clientNamesForwards')(this.home)}
- ${this.helpers.displayAddress(this.home.address)}
- Last sold: ${this.$filter('moment')(this.home.soldDate, 'MMMM, YYYY')}
${this._estimateBullet()}
${this._updatesBullet()}

${this.user.first_name}'s phone: ${this.$filter('phone')(this.user.mobile)}
Email: ${this.user.email}

Let me know what you think the value is!

${this.agent.first_name} ${this.agent.last_name}
Don't hesitate to call me with questions: ${this.$filter('phone')(this.$filter('mobile')(this.agent.phones))}


P.S. You can learn more about homebot here: http://homebot.ai/cma`;
  }

  _updatesBullet(){
    if(!this.home.answers.homeUpdatedDescription) return '';

    return `- Updates they made to the home: "${this.home.answers.homeUpdatedDescription}"`;
  }

  _estimateBullet(){
    if(!this.home.answers.isEstimateCorrect) return '';

    return `- They believe that ${this.$filter('money')(this.homeValue())} is ${this.$filter('estimateCorrect')(this.home.answers.isEstimateCorrect)}.`;
  }

}


if(typeof module !== 'undefined' && module.exports)
  module.exports = RecommendedReaCmaRequest;
else if(typeof window !== 'undefined')
  window.RecommendedReaCmaRequest = RecommendedReaCmaRequest;
